import React from 'react';

import { FormProvider } from 'react-hook-form';

import { QueryParams } from 'api/mutations/runQsraAnalysis.mutate';

import { CustomizedButton } from 'components/common';
import { useRunQsraFormLogic } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.logic';
import classes from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.module.scss';
import { useRunQsraFormProvider } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.provider';
import { NumberOfSimulations } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/components/NumberOfSimulations/NumberOfSimulations';
import { Period } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/components/Period/Period';
import { TargetActivity } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/components/TargetActivity/TargetActivity';

interface Props {
    latestVersionId: number;
    riskIds: number[];
    handleModalClose: () => void;
}

export interface FormProps extends QueryParams {
    taskVersionHashCode: string | null;
    taskVersionLabel: string | null;
    period: 'DAY' | 'WEEK';
}

export const RunQsraForm = ({ riskIds, latestVersionId, handleModalClose }: Props) => {
    const { api } = useRunQsraFormProvider();
    const { logic } = useRunQsraFormLogic({ api, riskIds, latestVersionId });

    return (
        <FormProvider {...logic.form}>
            <div className={classes.runQsraForm}>
                <form onSubmit={logic.form.handleSubmit(logic.handleSaveUseForm)} autoComplete="off">
                    <div className={classes.title}>Run QSRA</div>
                    <NumberOfSimulations />
                    <TargetActivity />
                    {/*<Period />*/}

                    <div className={classes.footer}>
                        <div className={classes.container}>
                            <CustomizedButton size={'large'} color={'secondary'} onClick={handleModalClose}>
                                Cancel
                            </CustomizedButton>

                            <CustomizedButton
                                type={'submit'}
                                size={'large'}
                                color={'primary'}
                                isLoading={api.runQsraAnalysis.instance.isLoading || logic.isRunningQsra}
                                disabled={api.runQsraAnalysis.instance.isLoading || logic.isRunningQsra}
                            >
                                Run!
                            </CustomizedButton>
                        </div>
                    </div>
                </form>
            </div>
        </FormProvider>
    );
};
